import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { QuotationBuilder } from "../components/QuotationBuilder";
import { fetchApi } from "@/services/apiService";
import type { QuotationLineItem } from "@/mocks/quotationsData";

export default function NewQuotationPage() {
  const [searchParams] = useSearchParams();
  const leadIdParam = searchParams.get("leadId");
  const useTemplateParam = searchParams.get("useTemplate");
  const preselectedLeadId = leadIdParam ? leadIdParam : null;

  const [templateItems, setTemplateItems] = useState<QuotationLineItem[] | null>(null);
  const [loading, setLoading] = useState(!!useTemplateParam);

  useEffect(() => {
    if (!useTemplateParam) return;
    setLoading(true);
    fetchApi<any[]>("/quotations/templates", undefined, [])
      .then((res) => {
        const list = Array.isArray(res) ? res : (res as any)?.data || [];
        const match = list.find((t: any) => String(t.id) === String(useTemplateParam));
        if (match && Array.isArray(match.items)) {
          setTemplateItems(
            match.items.map((item: any, idx: number) => ({
              id: idx + 1,
              description: item.description || "",
              qty: Number(item.qty) || 1,
              unit: item.unit || "Unit",
              rate: Number(item.rate) || 0,
              taxPercent: Number(item.taxPercent) || 0,
            }))
          );
        }
      })
      .catch((err) => console.error("Error loading template for quotation:", err))
      .finally(() => setLoading(false));
  }, [useTemplateParam]);

  if (loading) {
    return (
      <div className="p-12 flex flex-col items-center justify-center min-h-[50vh]">
        <i className="ri-loader-4-line animate-spin text-2xl text-indigo-600 mb-2" />
        <p className="text-sm text-gray-500">Loading template...</p>
      </div>
    );
  }

  return (
    <QuotationBuilder
      mode="create"
      preselectedLeadId={preselectedLeadId}
      initialData={
        templateItems
          ? {
              quoteNo: `QT-${Math.floor(1000 + Math.random() * 9000)}`,
              date: new Date().toISOString().split("T")[0],
              validUntil: new Date(Date.now() + 30 * 86400000).toISOString().split("T")[0],
              lead: null,
              agent: "",
              terms: "1. This quotation is valid for 30 days\n2. Payment terms: 10% on booking\n3. All prices inclusive of applicable taxes\n4. Subject to availability",
              items: templateItems,
              discount: 0,
            }
          : undefined
      }
    />
  );
}